import { AddOutlined, DeleteOutline, EditOutlined, List } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { CustomButton, FilterBar, TableData } from "../../../../components";
import { confirmAlert, errorAlert } from "../../../../helpers/alerts";
import { Box } from "@mui/material";
import { removePDSProduct, setCurrentPDSProduct, setPDSProducts, setPDSSegments, updatePDSProduct } from "redux/slices/admin/productSlice";
import { getAllPDSProductsService, getPDSSegmentsService, removePDSProductService, updatePDSProductService } from "services/admin/productService";
import { validatePermission } from "helpers/authentication";
import { sortArrayBy } from "helpers/util";

const ProductsPaymentServiceScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pdsSegments, pdsProducts } = useSelector((state) => state.products);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getPDSSegmentsService().then(list => {
      dispatch(setPDSSegments(list));
    }).catch(error => errorAlert(error))
    // eslint-disable-next-line
  }, []);

  const handlerSegments = () => navigate("segmentos");
  const handlerAdd = () => navigate("productos/crear");

  const handlerEdit = (row) => {
    dispatch(setCurrentPDSProduct(row));
    navigate("productos/editar");
  };

  const handlerCheck = async ({ id, idSegment }, currentValue, col) => {
    const value = !currentValue;
    updatePDSProductService(idSegment?.id, id, { [col]: value })
      .then(() => dispatch(updatePDSProduct({ id, data: { [col]: value } })))
      .catch(error => errorAlert(error))

  };

  const handlerDelete = ({ id, name, idSegment }) => {
    confirmAlert({
      title: "Estas seguro que deseas eliminar este producto?",
      text: `El producto ${name} será eliminado.`,
      onConfirm: async () => {
        try {
          await removePDSProductService(idSegment?.id, id,);
          dispatch(removePDSProduct(id));
        }
        catch (error) {
          errorAlert(error)
        }
      }
    })
  };

  const handlerChangeSegment = async (idSegment, product) => {
    updatePDSProductService(idSegment, product.id)
      .then(() => dispatch(updatePDSProduct({ id: product.id, data: { idSegment: { id: idSegment } } })))
      .catch(error => errorAlert(error))
  }

  const handlerSubmit = (data) => {
    setLoading(true);
    getAllPDSProductsService(data)
      .then((data) => dispatch(setPDSProducts(data)))
      .catch(error => errorAlert(error))
      .finally(() => setLoading(false))
  }

  return (
    <>
      <FilterBar
        handlerFilter={handlerSubmit}
        showTitle={false}
        filters={[
          {
            name: "segments",
            label: "Segmento",
            type: "select",
            multiple: true,
            data: pdsSegments.map(({ id, name }) => ({ id, name })),
            render: (value) => value.map((id) => {
              const segment = pdsSegments.find(o => o.id === id);
              return segment.name;
            }).join(', '),
          },
        ]}
      />
      <Box mt={-5} >
        <TableData
          dataRows={sortArrayBy(pdsProducts, a => a.name)}
          loading={loading}
          dataTitle={["Logo", "Nombre", "Código", "Segmento", "Estado"]}
          headerButtons={[
            <CustomButton
              icon={<List />}
              key="segments"
              name={"Segmentos"}
              click={handlerSegments}
            />,
            validatePermission('productos', 'productos', ['agregar']) &&
            <CustomButton
              dark={true}
              icon={<AddOutlined />}
              key="addProduct"
              name={"Producto"}
              click={handlerAdd}
            />,
          ]}
          formatter={({ name, code, state, idSegment, fd, fixedAmount, amounts }) => [
            { type: "img", value: `/v3/file/${fd}/` },
            name,
            fixedAmount ? amounts?.map(({ sku }) => sku).join(', ') : code,
            {
              name: "segment",
              type: "select_button",
              label: 'Segmento',
              list: pdsSegments.map(({ id, name }) => ({ id, name })),
              value: idSegment?.id,
              onChange: handlerChangeSegment
            },
            { name: "state", type: "boolean", value: state },
          ]}
          onChecked={handlerCheck}
          actions={[
            {
              label: "Editar",
              icon: <EditOutlined />,
              onClick: (data) => {
                handlerEdit(data);
              },
            },
            {
              label: "Eliminar",
              icon: <DeleteOutline />,
              onClick: (data) => {
                handlerDelete(data);
              },
            },
          ]}
        />
      </Box>
    </>
  );
};

export default ProductsPaymentServiceScreen;
